var i18n = require('i18n');
var util = require('./util');
var ajax = require('@enhancer/fe-util-ajax');
var setHash = util.setHash;
var pageSize = pageConfig.pageSize || 5;


module.exports = function pagination (url, topicList, rendered, processData, opt) {
	opt = opt || {};
	var cur = 1;
	var total = 0;
	var first = opt.search;
	url = url.indexOf('?') == -1 ? url + '?' : url + '&';

	var hash = location.hash;
	if (hash && !opt.refresh) {
		hash = hash.substring(1);
		var match = hash.match(/p=(\d+)/);
		if (match) {
			cur = parseInt(match[1], 10) || 1;
			if (cur !== 1) {
				match = hash.match(/t=(\d+)/)
				if (!match || !parseInt(match[1], 10)) {
					location.href = location.pathname;
				} else {
					total = parseInt(match[1], 10);
				}
			}
		}
	}

	if (opt.refresh) {
		$('.pagination').off('click');
	}

	

	function loadList (page, cb) {
		$('.topic-list').html('');
		$('.ui.enhancer-loading').addClass('loader');
		var plate = location.pathname.match(/^\/plate\/([^/]+)/);
		plate = plate ? plate[1] : pageConfig.defaultPlate;

		ajax({
			url: url + 'plate=' + plate + '&page=' + page + (opt.type ? '&type=' + opt.type : '') + (first ? '&tutorials=1' : '')
		},function (data) {
			
			$('.ui.enhancer-loading').removeClass('loader');
			if (data.success) {
				data = data.data;
				data.count = data.count || 0;
				
				if (page == 0) {
					if (data.count == 0) {
						$('.empty-list').text(i18n('common.no.data')).css('display', 'block');
						$('.pagination').css('display', 'none');
						$('.topic-list').css('display', 'none');
						rendered && rendered(page, data, first);
						first = false;
						return
					} else {
						$('.topic-list').css('display', 'block');
						$('.pagination').css('display', 'flex');
						$('.empty-list').css('display', 'none');
					}
					total = Math.ceil(data.count / pageSize);
				} else {
					$('.topic-list').css('display', 'block');
					$('.pagination').css('display', 'flex');
					$('.empty-list').css('display', 'none');
				}
				 

				data.col = (data.col || []);

				if (opt.showDelete) {
					data.col = data.col.reverse(); 
				}
				
				data.col.forEach( function (item) {
					processData && processData(item);
					item.create = util.handleDate(item.create);
					item.update = util.handleDate(item.update);
					var user = data.users[item.uid] || {
						avatar: util.defaultAvatar
					};
					item.avatar = user.avatar;
					item.nickname = user.nickname;
					
					item.projectName = pageConfig.projectName;
					item.tags = [];
					item.title = item.title.replace(/&lt;/g, '<').replace(/&gt;/g, '>');

					item.link_url = pageConfig.projectName + '/plate/' + (item.plate || plate) + '/topic/' + item._id
					item.plate = item.plate || plate;


					item.del = opt.showDelete && item.state === 0;
					if (item.del && opt.isMyself) {
						item.showDelete = true;
					}

					if ((item.type === 'question' || item.type === 'widget') && item.answer) {
						//item.title =   i18n('resolved') + ' ' + item.title; 
						item.resolved = true;
					}
					if (item.type === 'bug' && item.answer) {
						//item.title =  i18n('fixed') + ' ' + item.title; 
						item.fixed = true;
					}

					if (!opt.type || opt.type === 'all' || opt.type === 'essence') {
						if (item.top) {
							item.topText = i18n('top');
							// item.tags.push({
							// 	text: i18n('top'),
							// 	type: 'top'
							// })
						}
						if (item.essence) {
							item.tags.push({
								text: i18n('essence'),
								type: 'essence'
							})
						}
						item.type !== 'default' && item.tags.push({
							text: i18n(item.type),
							type: item.type
						});
					}
				});
				var html = topicList({
					data: data.col
				});
				$('.topic-list').html(html);
				rendered && rendered(page, data, first);
				cb && cb(data.col);

				var pageInfo = {
					p: page  + 1
				};
				if (page === 0 && total > 0) {
					pageInfo.t = total;
				}
				setHash(pageInfo);
				first = false;
			} else {
				util.show(data.message);
			}
		});
	}

	function changePagination (cur, total) {
		var index;
		var html = '';
		var prev = '<a class="icon item"><i class="left arrow icon"></i></a>';
		var next = '<a class="icon item"><i class="right arrow icon"></i></a>';
		var disabled = '<div class="disabled item">...</div>';
		html += prev;

		if (cur < 5) {
			var end = Math.min(5, total);
			for (var i = 0; i < end; i++) {
				index = i + 1;
				html += `<a class="item ${index == cur ? 'active' : ''}">${index}</a>`;
			}
		} else {
			var end =  Math.min(cur + 2, total);
			html += '<a class="item">1</a>';
			html += disabled;
			for (var i = cur - 2; i < end; i++) {
				index = i + 1;
				html += `<a class="item ${index == cur ? 'active' : ''}">${index}</a>`;
			}
		}
		html += next;
		$('.pagination').html(html);
	}
	$('.pagination').on('click', '.item', function (e) {
		if ($(this).hasClass('disabled')) {
			return;
		}
		var icon = $(this).find('.icon');
		if (icon.length) {
			if (icon.hasClass('left')) {
				cur > 1 && $('.pagination .active').prev().click();
			} else {
				cur < total && $('.pagination .active').next().click();
			}
		} else {
			var old = cur;
			cur = parseInt($(this).text(), 10);
			if (old === cur) {
				return
			}
			changePagination(cur, total, 'page');
			loadList(cur - 1);
		}
	});

	loadList(cur - 1, function (data) {
		if (data.length) {
			changePagination(cur, total);
		}
	})
}



// WEBPACK FOOTER //
// ./src/app/pagination.js